export default __webpack_public_path__ + "static/fire_door_w.f9ab80b1734dc5f0efb42fa7bc2cd639.png";